import { type ThunkAction } from "redux-thunk";
import { type AnyAction } from "~/app/store/types";
import { getData } from "~/features/cart/activeQuote/api/quoteView";
import { orchestratePnARefresh } from "~/features/cart/cart/redux/actions/cartRefresh";
import { updateOfferPrice } from "~/features/cart/cart/redux/actions/cartQuoteCommonActions";
import { type RootState } from "~/app/store";
import { selectLineItemsByProduct } from "~/features/cart/cart/redux/selectors/cartSelectors";
import { CART_LOAD_FAIL, CART_LOAD_START, CART_LOAD_SUCCESS } from "~/features/cart/cart/redux/actions";

export {
  deletePackageEntry,
  clearCart as clearQuote,
  updateQuantity,
  updatePackageEntryPk,
  updateDate,
  updateComment,
  updateInternalComment,
  toggleCommentVisibility,
  updateOfferPrice,
  updateTargetPrice,
} from "~/features/cart/cart/redux/actions/cartQuoteCommonActions";

type ThunkResult<R> = ThunkAction<R, RootState, undefined, AnyAction>;

export function activeQuotePageMounted(): ThunkResult<void> {
  return async (dispatch) => {
    dispatch({ type: CART_LOAD_START });

    try {
      const data = await getData();
      dispatch({
        type: CART_LOAD_SUCCESS,
        payload: data,
      });

      // if (Object.values(data.cartEntriesById).length <= CART_PNA_THRESHOLD) {
      //   dispatch(performCartRefresh());
      // } else {
      //   dispatch(addMessage(
      //     'info',
      //     instance.t('page.cart.message.abovePnaThreshold', {count: CART_PNA_THRESHOLD})
      //   ));
      // }
      dispatch(performCartRefresh());
    } catch {
      dispatch({ type: CART_LOAD_FAIL });
    }
  };
}

function performCartRefresh(): ThunkResult<void> {
  return (dispatch, getState) => {
    const lineItemsByProduct = selectLineItemsByProduct(getState());
    const entries = Object.values(lineItemsByProduct);
    entries.sort((a, b) => (a[0].entryNumber ?? 0) - (b[0].entryNumber ?? 0));

    // A05/A07 dependency: cartRefresh.ts is owned by the cart lane (A07); this dispatch stays
    // intact and is the remaining cart-side PnA refresh entry point for the quote load.
    entries.forEach((lineItems) => dispatch(orchestratePnARefresh(lineItems)));
  };
}

export function blurOfferPrice(packageId: number): ThunkResult<void> {
  return (dispatch, getState) => {
    const state = getState().cart;
    const packageEntry = state.packageEntriesById[packageId];

    const newPrice = packageEntry.offerPrice && packageEntry.offerPrice.value > 0 ? packageEntry.offerPrice : undefined;

    dispatch(updateOfferPrice(packageId, newPrice));
  };
}
